const localHosts = new Set(['localhost', '127.0.0.1']);

export const API_BASE = localHosts.has(window.location.hostname) ? 'http://localhost:3000/api' : '/api';

export function params(filters: Record<string, string | undefined>): string {
  const search = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : '';
}
